<template>
  <!-- 微动画 -->
  <div class="micro-animation cosplay-box">
    <template v-if="!isEnded">
      <div class="play-video-box">
        <div class="prism-player" id="J_prismPlayer" v-if="isshowVideo"></div>
        <div class="video-controls">
          <em
            @click="changeType"
            class="controls-btn"
            :class="{'pause-icon':plsyStatus == 'play', 'play-icon':plsyStatus=='paused'}"
          ></em>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cosplay-empty" v-if="!isChooseRole">
        <img v-if="$Tool.getStorage('languageType') == 'zh'" class="empty-tip" src="@/assets/images/studyCenter/video-empty-icon.png" alt />
        <img v-else class="empty-tip" src="@/assets/images/studyCenter/video-empty-icon-tw.png" alt />
        <div class="empty-btns">
          <span class="btn play-btn" @click="replay">{{$t('blendType.Replay')}}</span>
          <span class="btn re-choose-btn" @click="chooseRole">Role-Play</span>
        </div>
      </div>
      <div class="choose-role-box" v-else>
        <ul>
          <li v-for="(item, index) in cosplayData.medias" :key="index" @click="currentVideoIndex = index, chooseIndex = index">
            <img :src="item.medias_smallimg" alt />
            <span v-if="index == chooseIndex" class="choose-icon"></span>
          </li>
        </ul>
        <div class="choose-btn" :class="{'disabled': currentVideoIndex < 0}" @click="choose">Next</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "cosplay",
  props: ["cosplayData", "from"],
  data() {
    return {
      isFirst: true,
      isEnded: false, // 视频 是否结束
      isChooseRole: false, // 选择 角色
      currentVideo: null,
      currentVideoIndex: 0,
      chooseIndex: -1,
      plsyStatus: "play",
      playObj: {},
      playState: true,
      isId: "",
      isshowVideo: true
    };
  },
  methods: {
    replay() {
      this.isEnded = false;
      this.$nextTick(() => {
        this.init();
      });
    },
    chooseRole() {
      this.isChooseRole = true;
    },
    choose() {
      if (this.chooseIndex != -1) {
        this.isChooseRole = false
        this.isFirst = true // 重复看 给金币
        this.chooseIndex = -1
        this.replay()
      }
    },
    changeType(p1, p2) {
      // this.$emit("changeType", p1, p2);
      if (this.playState == true) {
        this.plsyStatus = "paused";
        this.playObj.pause();
        this.playState = false;
      } else {
        this.plsyStatus = "play";
        this.playObj.play();
        this.playState = true;
      }
    },

    init() {
      var _this = this;
      this.currentVideo = this.cosplayData.medias[this.currentVideoIndex];
      this.playObj = new Aliplayer(
        {
          id: "J_prismPlayer",
          source: this.currentVideo.medias_audio,
          width: "100%",
          height: "97%",
          autoplay: true,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true,
          controlslist: 'nodownload',
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "blabs",
              x: 30,
              y: 80
            },
            {
              name: "H5Loading",
              align: "cc"
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0
            },
            {
              name: "infoDisplay"
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56
            },
            {
              name: "thumbnail"
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12
                },
                {
                  name: "volume",
                  align: "tr",
                  x: 5,
                  y: 10
                }
              ]
            }
          ]
        },
        function(player) {
          let video = document.querySelector("#J_prismPlayer video");
          video.setAttribute('controlslist', 'nodownload')
          video.setAttribute('disablePictureInPicture', true)
          player.play();
          video.addEventListener(
            "ended",
            () => {
              _this.isEnded = true;
              // if (_this.isFirst) {
                _this.$emit('changeType', {})
                // _this.isFirst = false
              // }
            },
            false
          );
        }
      );
    }
  },
  created() {
    this.isId = this.$route.query.id;
  },
  watch: {
    cosplayData(n) {
      if (!this.isEnded) {
        this.init();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.isEnded) {
        this.init();
      }
    });
  }
};
</script>

<style lang="less">
.prism-tooltip {
  color: white;
}
.controls-btn {
  width: 40px !important;
  height: 40px !important;
}

.cosplay-box {
  padding: 0;
}

.cosplay-empty {
  height: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .empty-tip {
    width: 265px;
    height: 210px;
  }

  .empty-btns {
    display: flex;
    width: 100%;
    padding: 15px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #ddd;
    position: absolute;
    bottom: -70px;
    left: 0;
    .btn {
      height: 40px;
      padding: 0 16px;
      line-height: 40px;
      border-radius: 20px;
      color: #fff;
      background-color: #ff5c67;
      cursor: pointer;
      &:first-child {
        margin-right: 20px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.choose-role-box {
  height: calc(100% - 50px);
  position: relative;
  ul {
    padding: 30px 50px;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      height: 180px;
      margin: 0 50px 30px 0;
      border-radius: 10px;
      position: relative;
      cursor: pointer;
      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
      .choose-icon {
        width: 34px;
        height: 29px;
        position: absolute;
        top: 0;
        right: 0;
        background: url(../../../assets/images/studyCenter/choose-icon.png) center center no-repeat;
        background-size: cover;
      }
    }
  }

  .choose-btn {
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 25px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 17px;
    color: #fff;
    background-color: #ff5c67;
    border-radius: 20px;
    cursor: pointer;
    &.disabled {
      color: #aaa;
      background-color: #e3e3e3;
    }
  }
}
</style>